<div class="dashboard-shell flex w-full min-h-[calc(100vh-65px)] bg-[var(--background)]">

  <!-- ── Left Vertical Sidebar (Desktop Fixed + Mobile Slide-Out Drawer) ── -->
  <aside
    *ngIf="!isTreasurePickRoute()"
    class="dashboard-sidebar-column shrink-0"
  >
    <app-side-bar></app-side-bar>
  </aside>

  <!-- ── Main Content Viewport ── -->
  <main
    class="dashboard-viewport flex-1 min-w-0 flex flex-col"
    [class.has-sidebar]="!isTreasurePickRoute()"
    [ngClass]="isSpinnerModule() ? 'mb-[20px] lg:mb-0' : ''"
  >
    <div class="viewport-inner w-full flex-1">
      <router-outlet></router-outlet>
    </div>
  </main>

</div>
